import NaturalPersonFormFields from './NaturalPersonFormFields';

export default NaturalPersonFormFields;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-form/natural-person-form-fields/index.js